import { EHttpErrorCode } from "./types";

/**
 * Checks whether a given value is a valid {@link EHttpErrorCode}.
 *
 * This function safely validates numeric enum values at runtime,
 * accounting for TypeScript's numeric enum reverse mappings.
 *
 * @param value - The value to validate
 * @returns `true` if the value is a valid `EHttpErrorCode`, otherwise `false`
 */
export function isEHttpErrorCode(value: unknown): value is EHttpErrorCode {
  return (
    typeof value === 'number' &&
    Object.values(EHttpErrorCode).includes(value)
  );
};
